module.exports = {
  menu: {
    home: 'ホーム',
    game: 'ゲーム',
    connect_login: 'ウォレット接続/ログイン',
    new_game: 'ゲームに参加',
    invite_friends: '友達を招待',
    cms_login: 'CMSログイン',
    register: '登録',
    login: 'ログイン',
    logout: 'ログアウト',
    login_to_play_game: 'ゲームをプレイするにはログインしてください',
    select_login_method: 'ログイン方法を選択してください',
    select_register_method: '登録方法を選択してください',
    email: 'メール',
    meta_mask: 'MetaMask',
    player_login: 'プレイヤーログイン',
    history: '戦績',
    transaction_history: '取引履歴',
    ranking: 'ランキング',
    purchase: 'チャージ',
    search_game_placeholder: 'ゲームを検索...',
    new_games: '新しいゲーム',
    frequent: 'よくプレイするゲーム',
    faq: 'よくある質問',
    terms_and_conditions: 'Win4Poker ポーカーの利用規約',
    tnc: '利用規約',
    about_us: '私たちについて',
    contact_us: 'お問い合わせ',
    settings: '設定',
    lucky_draw: 'ラッキードロー',
    tournament: 'トーナメント',
    announcement: 'お知らせ',
    no_news: 'ニュースがありません',
    online: 'オンライン',
    deposit: '入金',
    terms_1_title: '参加資格',
    terms_1_content:
      'すべてのプレイヤーは18歳以上であり、法律で許可されている地域で登録およびゲームを行う必要があります。',
    terms_2_title: 'アカウント登録',
    terms_2_content: 'プレイヤーは公式ウェブサイトを通じてアカウントを登録する必要があります。',
    terms_3_title: 'ゲームルール',
    terms_3_content:
      'すべてのゲームは標準ポーカールールに従わなければならず、不正行為はアカウントの一時停止または閉鎖につながります。',
    terms_4_title: '入金と出金',
    terms_4_content:
      'プレイヤーはこのプラットフォームの支払い方法を使用して入金する必要があり、出金はプラットフォームの処理時間に従って行われます。',
    terms_5_title: 'ボーナス分配',
    terms_5_content:
      'ボーナスはゲーム結果に基づいて分配され、具体的なルールはゲーム開始前に説明されます。',
    terms_6_title: '責任の制限',
    terms_6_content:
      'プラットフォームは、サービスや製品の使用中に発生する損失や損害について責任を負いません。',
    terms_7_title: 'プライバシー保護',
    terms_7_content:
      'プレイヤーの個人情報は機密として扱われ、アカウント管理およびゲーム目的のみに使用されます。',
    terms_8_title: '規約の変更',
    terms_8_content:
      'プラットフォームは、規約および条件をいつでも変更する権利を留保し、変更はメールまたはウェブサイトのお知らせを通じてプレイヤーに通知されます。',
    location_restricted_title: '地域制限',
    location_restricted_content:
      '現在お住まいの地域は制限されています。一部の機能やサービスが利用できない場合があります。ご理解いただきありがとうございます。',
  },
  common: {
    theme: '基礎プロジェクト管理',
    delete_record_confirm_msg: '削除を確認しますか？',
    yes: 'はい',
    no: 'いいえ',
    true: 'はい',
    false: 'いいえ',
    success: '成功',
    loading: '読み込み中',
    or: 'または',
    delete: '削除',
    login: 'ログイン',
    submit: '送信',
    apply: '適用',
    cancel: 'キャンセル',
    confirm: '確認',
    back_to_lobby: 'ロビーに戻る',
    email: 'メール',
    id_document: '身分証明書',
    all_in_game: 'オールインフォールドテキサスホールデム',
    all_in_game_omaha: 'オールインフォールドオマハ',
    regular: 'テキサスホールデム',
    regular_description: 'テキサスホールデムは無制限ベットで行われます',
    short: 'ショートデッキ',
    short_description: 'ショートデッキテキサスホールデムは36枚のカードで行われます',
    omaha: 'オマハ',
    omaha_description: 'プレイヤーは2枚のホールカードを使用してハンドを作成する必要があります',
    regular_allin: 'オールインフォールドテキサスホールデム',
    omaha_allin: 'オールインフォールドオマハ',
    tournament: 'トーナメント',
    start: 'テーブルを開く',
    game_demo_area: 'ゲーム体験エリア',
    total_win_prize: '総獲得賞金',
    waiting_list_order: 'ウェイティングリスト順',
    join_more_than_4_room_error: '4つ以上のルームに参加できません',
    system_message: 'システムメッセージ',
    error: 'エラー',
    register: '登録',
    meta_mask: 'MetaMask',
    wallet_connect: 'Wallet Connect',
    password: 'パスワード',
    next_step: '次のステップ',
    next: '次へ',
    verify: '認証',
    copy_success: 'コピーに成功しました',
    enabled: '有効',
    enable: '有効にする',
    disable: '無効にする',
    done: '完了',
    feature_in_progress: 'おすすめ機能は開発中です。後ほどご確認ください。',
    no_data: 'データがありません',
    date: '日付',
    retry: '再試行',
    location_restricted_title: '地域制限',
    location_restricted_content:
      '現在いる地域は制限されています。一部の機能やサービスが利用できない場合があります。ご理解いただきありがとうございます。',
    dont_show_again: '今後表示しない',
    edit: '編集',
    i_am_not_located_in_the_restricted_country: '地域制限されている国にいません',
  },
  auth: {
    nickname: 'ニックネーム',
    connect_to_win_4_poker: 'WIN 4 POKERに接続',
    wallet_connect_need_to_connect_ur_wallet:
      'アプリケーションはあなたのウォレットへの接続を必要とします',
    wallet_connect_sign_this_message:
      'このメッセージに署名してウォレットを所有していることを証明し、続行してください。キャンセルすると接続が切断されます。',
    sign_request_in_wallet: 'ウォレットでリクエストに署名',
    sign_message_success: '署名に成功しました',
    cancel: 'キャンセル',
    sign: '署名',
    confirm_password: 'パスワードの確認',
    referral_code: '紹介コード',
    i_have_read_the_agreement: '私は契約に同意します',
    should_accept_agreement: '契約に同意してください',
    alphabet_validation: '少なくとも1つのアルファベット文字を含めてください',
    numeric_validation: '少なくとも1つの数字を含めてください',
    length_validation: '8文字以上、20文字以下で入力してください',
    placeholder: {
      enter_user_name: 'ユーザー名を入力',
      enter_email: 'メールを入力',
      enter_password: 'パスワードを入力',
      confirm_password: 'パスワードを確認',
      enter_referral_code: '紹介コードを入力',
    },
    error_messages: {
      nickname: 'ニックネームを入力してください',
      email_invalid: '無効なメールアドレスです',
      email_required: 'メールアドレスを入力してください',
      password_required: 'パスワードを入力してください',
      password_confirm_required: 'パスワードを確認してください',
      password_confirm_not_matched: '入力された2つのパスワードが一致しません！',
      incorrect_email_or_password: 'メールアドレスまたはパスワードが正しくありません',
      error_occurred: 'エラーが発生しました。後でもう一度お試しください',
    },

    // login-email page
    forget_password: 'パスワードを忘れましたか？',

    // forgot-password page
    forgot_password_title: 'パスワードを忘れました',
    please_enter_email_registered: '登録されたメールアドレスを入力してください',

    // email-verification page
    email_verification: 'メール認証',
    email_has_been_sent_to: '{{value}}にメールが送信されました',
    email_resend_countdown_message:
      'メールが届きませんか？<0>カウントダウン</0>秒後にメールの再送信をリクエストできます',
    please_check_your_email: 'メールを確認してください',
    waiting_to_verify_email: 'メールの認証を待っています',
    agree_terms_and_privacy:
      'このプロセスを続行することで、<0>利用規約</0>と<1>プライバシーポリシー</1>に同意したことになります。',
    terms: '利用規約',
    privacy_policy: 'プライバシーポリシー',

    // metamask-complete-registration page
    complete_metamask_registration: 'MetaMask登録を完了',

    // reset-password page
    reset_password: 'パスワードをリセット',
    you_may_now_reset_password: 'あなたは今、アカウントのパスワードをリセットできます。',

    register_an_account: 'まだアカウントをお持ちでないですか？<0>ここで登録</0>！',
    resend_code_message: 'メールが届きませんか？ここをクリックして<0>再送信</0>してください',

    // 2FA setup page
    two_fa_via_email_title: 'メールによる二段階認証',
    otp_has_been_sent_to_email: 'ワンタイム認証コードが登録されたメールアドレスに送信されました。',
    two_factor_authentication: '二段階認証',
    scan_this_qr_code_msg:
      '二段階認証(2FA)を設定するには、AuthyやGoogle AuthenticatorなどのアプリでこのQRコードをスキャンしてください。',
    choose_scan_qr_code_msg:
      '認証アプリを開き、右下の+アイコンをクリックします。QRコードのスキャンを選択します。',
    choose_enter_setup_key_msg:
      '認証アプリを開き、右下の+アイコンをクリックします。設定キーの入力を選択します。',
    secret_key: 'シークレットキー',
    enter_code_in_authenticator_app: '認証アプリに表示されているコードを入力してください。',
    two_fa_is_set: {
      title: '2FAが設定されました',
      message: '2FAが設定され、出金機能が利用可能になりました。',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function: 'メール認証を完了してXXX機能をアンロック',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '身分証明書認証を完了して出金額を100,000 USDTにアップグレード',

    requirement: '要件',
    verify_now: '今すぐ認証',

    verification_code: '認証コード',

    id_card: '身分証明書',
    passport: 'パスポート',

    identity_verification: {
      title: '身分証明書認証',
      msg: '有効な身分証明書を使用して認証してください。',
      issuing_country: {title: '発行国を選択', placeholder: '国を選択'},
      document_type: {
        title: '身分証明書の種類を選択',
        placeholder: '身分証明書の種類を選択',
      },
    },

    uploadDocument: {
      title: 'ドキュメントのアップロード',
      make_sure_that_your: 'ドキュメントが',
      is_clear_and_easy_to_read: '明確で読みやすいことを確認してください',
      is_unedited: '編集されていないこと',
      the_whole_doc_must_appear_in_photo: 'ドキュメント全体が写真に写っていること',
      no_reflective_glare: '反射光がないこと',

      upload_image: '写真をアップロード',
      upload_image_requirement: 'ファイルサイズは10MB未満で、jpegまたはpng形式をサポートします。',
      front_side_of_id: '身分証明書の表面',
      back_side_of_id: '身分証明書の裏面',
      personal_data_page_of_passport: 'パスポートの個人データページ',
      document_uploaded: 'ドキュメントがアップロードされました',
      id_document_under_review_msg:
        'あなたの身分証明書は審査中であり、認証が完了するまでに1〜2営業日かかる場合があります。',
    },

    disable_2fa: {
      title: '二段階認証を無効にする',
      description:
        '操作を続行するには、認証アプリで提供された認証コードを入力して本人確認を行ってください',
      success_message: '二段階認証を無効にしました',
    },
    connect_wallet_to_spin: 'ウォレットを接続',

    // enter code page
    link_email: 'メールをリンク',
    unlink_email: 'メールをアンリンク',
    expires_in: '期限内 <0>分</0>.',
    resend_code: '<0>コードを再送信</0>',
    enter_code: 'コードを入力',
    unlink_email_confirm_msg: 'メールをアンリンクしてもよろしいですか？',
    link_success: 'メールがリンクされました',
    unlink_success: 'メールがアンリンクされました',
  },
  slider: {
    about: '約',
    support: 'サポート',
  },
  game_room: {
    confirm_leave_msg: 'ゲームを離れることを確認しますか？',
    join_room_error_title: 'ルーム参加エラー',
    join_room_error_msg: 'ルームへの参加に失敗しました。もう一度お試しください',
    confirm_withdraw_extra_bet_msg: '追加チップを引き出すことを確認しますか？',
    total_won_prize: '合計獲得: ${{val, number}}',
    your_balance: '残高: ${{val, number}}',
    no_enough_balance: '最低購入チップ数 ${{val, number}} に満たない残高',
    cash_out: 'チップを現金化して退出',
    continue_game: 'ゲームを続ける',
    remark_placeholder: '備考',
    leave_seat: '席を離れる',
    sit_in: '席に戻る',
    buy_in: '購入',
    buy_in_min_amount: '最低',
    buy_in_max_amount: '最高',
    seconds: '秒',
    close_drawer: '閉じる',
    leave_game: 'ゲームを離れる',
    back_to_lobby: 'ロビーに戻る',
    leave_table: 'テーブルを離れる',
    you_have_copied_room_code: 'ルーム招待コードをコピーしました: {{value}}',
    invitation_message:
      '{{playerName}}が作成したゲームルームに今すぐ参加！ ルーム招待コード {{roomNumber}}、ゲームを始めましょう！',
    link_copied: 'リンクをコピーしました',
    please_wait_until_connected: '接続までお待ちください',
    rejoin_room: 'ルームに戻る',
    theme_setting: 'テーマ設定',
    room_code_share: 'ルーム招待コードをコピー',
    room_link_copy: 'リンクを共有',
    table_setting: 'テーブル設定',
    emoji_menu: '絵文字メニュー',
    history_drawer: 'ルーム履歴',
    deposit: '入金',
    withdraw_extra_bet: '追加チップを引き出す',
    add_extra_bet: '追加チップを補充',
    unit_convert: '単位変更',
    silent_mode_on: 'サイレントモード: ON',
    silent_mode_off: 'サイレントモード: OFF',
    raise_to: 'ベット額',
    winner: '勝者',
    player_status: {
      disconnected: 'オフライン',
      sat_out: '席を外す',
    },
    win_percentage: '勝率',
    all_in: 'オールイン',
    ping_popup_msg: 'ネットワーク信号が不安定です。再接続を試みています',
    ping_popup_title: 'ネットワーク信号が不安定',
    ping_popup_content: '再接続を試みています。ページをリフレッシュしてみてください',
    disconnected_modal_title: 'ネットワーク信号が不安定',
    afk_timer_text:
      '長時間反応がないため、席を外されました。時間内に戻らないとルームから退出されます',
    regular: 'テキサスホールデム',
    short: 'ショートデッキ',
    omaha: 'オマハ',
    omaha_all_in: 'オールインフォールドオマハ',
    buyin_option: '購入オプション',
    buy_in_amount: '購入金額',
    reminder: 'リマインダー',
    not_enough_balance_to_buy_in: '購入するための残高が不足しています。',
    sitting_out: '席を外す',
    not_leaving_temporarily: '一時的に退出しない',
    back_to_home: 'ホームに戻る',
    are_you_sure_leave_table:
      'あなたは最も高いベットを持つプレイヤーです。退出してもよろしいですか？',
    leave_table_with_highest_bet_error:
      'あなたは最も高いベットを持つプレイヤーです。テーブルを離れることができません。後でもう一度お試しください。',
    loading_room_data: 'ルームデータを読み込んでいます...',
    sit_out_tournament_warning: {
      title: 'トーナメント席離れ警告',
      msg: '現在トーナメントに参加中です。席を外しても、ブラインドの支払いは必要です。',
    },
  },
  player_action: {
    bet: 'ベット',
    call: 'コール',
    check: 'チェック',
    raise: 'レイズ',
    fold: 'フォールド',
    bb: 'ビッグブラインド',
    sb: 'スモールブラインド',
    ante: 'アンティ',
    all_in: 'オールイン',
    insurance_cancel: '保険をキャンセル',
    insurance_buy: '保険を購入',
  },
  game_demo: {
    experience_progress: '体験コードの進捗',
    game_experience_zone: 'ゲーム体験ゾーン',
    action_to_redemption: '30ゲームの有効プレイで現金コードと交換',
    remaining_game_experience_code: '残り{{val, number}}個',
    cash_code_exchange: '現金コード交換',
    successfully_finish_30_games: '正常に完了しました',
    congrats: 'おめでとうございます！',
    successful_exchange_cash_code: '{{amount}}現金コードの交換に成功しました',
    how_to_redeem: '体験コードの現金コードへの交換方法',
    successful_condition_of_redemption: '条件: 30ゲームの有効プレイを達成',
    two_to_three_players: '2-3人のゲーム',
    explanation_of_valid_game:
      '10BBに達し、エンドゲームで自分のハンドをオープンする必要があります。これで有効なゲームとカウントされます',
    more_than_four_players: '4人以上のゲーム',
  },
  userProfile: {
    profile_settings: 'プロフィール設定',
    initial_setting_title: 'Win4.Pokerへようこそ',
    initial_setting_description: '以下の初期設定を完了し、私たちのゲームをお楽しみください',
    display_name: '表示名',
    profile_picture: 'プロフィール画像',
    edit: '編集',
    balance: '残高',
    coin: 'USD',
    demo_coin: '現金体験コード',
    diamond: 'ダイヤモンド',
    game_record: 'ゲーム記録',
    ranking_list: 'ランキングリスト',
    game_review: 'ゲームレビュー',
    shortcut_setting: 'ショートカット設定',
    user_name: 'ユーザー名:',
    recommend_code: '紹介コード',
    upload_image_msg: '画像をここにドラッグするか、',
    upload_image_browser_msg: 'ブラウザで選択',
    upload_image_file_size: '(ファイルサイズ最大: 68px*93px)',
    username_length_message: 'ユーザー名の長さは3-24文字である必要があります',
    chinese_username_length_message:
      '中国語文字を含むユーザー名の長さは1-5文字である必要があります',
    username_char_message:
      "ユーザー名はアルファベット、数字、中国語文字、および'_'/'-'/'.'のみを含めることができます",
    personal_information: '個人情報',
    user_icon: 'ユーザーアイコン:',
    save: '保存',
    my_profile: 'マイプロフィール',
    my_balance: '私の残高',
    deposit_withdraw: '入金/出金',
    my_record: '私の記録',
    flow_record: 'フロー記録',
    total_earnings: '総収益',
    country: '国',
    disclaimer: '免責事項',
  },
  maintenance: {
    title: 'ウェブサイトはメンテナンス中です',
    content:
      'ユーザーエクスペリエンスを改善するために努力しています。すぐに戻ります。ご理解いただきありがとうございます。',
  },
  useSetting: {
    card_front: 'カード表面',
    card_back: 'カード裏面',
    table: 'テーブル',
    add_token_msg: 'さらにトークンを入金しますか？',
  },
  lucky_draw: {
    award_history: '受賞履歴',
    lucky_draw_rules: 'ルール',
    remaining_lucky_draw_amount: '残りのスピン回数: {{value}}',
    remaining_lucky_draw_amount_loading_label: '残りのスピン回数: ',
    spin_wheel_10_times: 'ホイールを10回回す',
    spin_wheel: 'ホイールを回す',
    participation_rate: 'ゲーム参加率: {{count}}',
    coin_loss: 'コイン損失率',
    congrats: 'おめでとうございます！',
    you_have_won: 'あなたは${{prize}}を獲得しました',
    collect_prize: '賞品を受け取る',
    select_category: '抽選カテゴリを選択: ',
    special_combination: '特別な組み合わせ: ',
    no_history: '抽選履歴が見つかりません',
    no_data: 'データがありません',
    spin: 'スピン',
    fortune_wheel: 'フォーチュンホイール',
    christmas_fortune_wheel: 'クリスマスフォーチュンホイール',
    new_year_fortune_wheel: '新年フォーチュンホイール',
    cny_fortune_wheel: '中国の新年フォーチュンホイール',
    email_login: 'メールログイン',
    thank_you: 'ありがとうございます',
    miss_msg_1:
      'イベントにご参加いただきありがとうございます。残りのスピンはありませんが、ゲームに参加してもっとお金を稼ぐことができます。楽しんで、幸運を祈ります。',
    play_now: '今すぐプレイ',
    win_msg:
      'あなたは勝ちました <br/> <large>{{prize}}</large> <br /> そして、あなたの残高に保存されました。',
    draw_again_msg:
      '<yellow>{{numOfDraws}}</yellow> 回のドローが残っています。<clickable>もう一度ドローするにはクリックしてください。</clickable>',
    diamond: '{{value}} ダイヤモンド',
    redeem_now: '今すぐ交換',

    deposit_more_than_10: '$10以上入金する',
    get_1_free_spin: '1回の無料スピンを獲得',
    win_10_times: '10回勝利する',
  },
  combination: {
    hi_card: 'ハイカード',
    pair: 'ペア',
    one_pair: 'ワンペア',
    two_pairs: 'ツーペア',
    set: 'スリーオブアカインド',
    three_of_a_kind: 'スリーオブアカインド',
    straight: 'ストレート',
    flush: 'フラッシュ',
    fullHouse: 'フルハウス',
    full_house: 'フルハウス',
    quad: 'フォーオブアカインド',
    straight_flush: 'ストレートフラッシュ',
    royal_flush: 'ロイヤルフラッシュ',
  },
  room_type: {
    public: '公開ルーム',
    private: 'プライベートルーム',
  },
  forgot_password: {
    reset_password: 'パスワードをリセット',
    password: 'パスワード',
    confirm_password: 'パスワードを確認',
    phone: '電話',
  },
  error: {
    please_confirm: '確認してください',
    password_inconsistent: 'パスワードが一致しません',
    file_size_limit_error: 'アップロードファイルサイズの制限は{{size}}です',
    please_input: '{{field}}を入力してください',
  },
  translation: {
    success: '成功',
  },
  game_list: {
    table: 'テーブル',
    random_join_table: 'ランダムにテーブルに参加',
    random_join: 'ランダムに参加',
    join: '参加',
    no_room_available: 'ルームがありません。後ほどお戻りください。',
    all_game_loaded: 'すべてのゲームが読み込まれました',
    join_waiting_list: 'ウェイティングリストに参加',
    join_table: 'テーブルに参加',
    join_observer: '観戦',
    game_code: 'テーブルコード',
    game_type: 'ゲームタイプ',
    game_limit: '人数制限',
    game_players: 'プレイヤー数',
    game_unit_test: 'ユニットテスト',
    game_basicBet: '基本ベット',
    game_SB: 'SB',
    game_smallBlind: 'スモールブラインド',
    regular: 'テキサスホールデム',
    all_in: 'オールインフォールドテキサスホールデム',
    short: 'ショートデッキ',
    omaha: 'オマハ',
    omaha_all_in: 'オールインフォールドオマハ',
    buy_in: '購入',
    tables: 'テーブル',
    notice: '通知',
    time_difference_reminder:
      'システム時刻とインターネット時刻に異常な差異があります。これはプレイヤーのカウントダウン機能に影響を与える可能性があります。最適なパフォーマンスと正確さを確保するために、できるだけ早くシステム時刻を同期してください。',
    player_category: 'プレイヤーカテゴリ',
    blind_category: 'ブラインドカテゴリ',
    table_category: 'テーブルカテゴリ',
    chips: 'チップ',
    player: 'プレイヤー',
    waiting: '待機中',
    avg_pot: '平均ポット',
    flop_rate: 'フロップ率',
    hands_per_hour: '1時間あたりのハンド数',
    no_of_hands_played: '総ハンド数',
    win: '勝ち',
    invested: '投資',
    pot: 'ポット',
    usd_balance_updated: 'USD残高が${{balance}}に更新されました',
    new_room: '新しいルーム',
    game: '現金ゲーム',
    tournament: 'トーナメント',
  },
  game_review: {
    my_bets: '私のベット',
    date_range: '日付範囲',
    select_date_range: '日付範囲を選択',
    show_all_dates: 'すべての日付を表示',
    show_selected_dates: '選択された日付を表示',
    no_game_record: 'ゲーム記録がありません',
    win_row_message: 'WIN!!',
    lose_row_message: '支出',
    ante: 'アンティ',
    win: '勝ち',
    lose: '負け',
    main_pot: 'メインポット',
    side_pot: 'サイドポット{{number}}',
  },
  leader_board: {
    rank: '順位',
    name: '名前',
    win_game: '累計勝利',
    score: 'スコア',
  },
  home: {
    dont_miss_promotion_msg: 'お見逃しなく',
    all_promotions: 'すべてのプロモーション',
    my_game: '私のゲーム',
    all_games: 'すべてのゲーム',
    claim_first_time_reward_button: '詳細',
    first_time_login: '初めてゲームにログインすると、',
    first_time_reward_msg: '{{val}}枚の体験コインを獲得します',
    open_table: 'テーブルを開く',
    open_new_room: '新しいルームを作成',
    enter_room_number: 'ルームコードを入力',
    start: 'テーブルを開く',
    enter_code: '引き換えコードを入力',
    confirm: '確認',
    game_selection: 'ゲーム選択',
    start_game: 'テーブルを開く/ルームに参加',
    game_record: 'ゲーム記録',
    join_private_room: 'プライベートルームを招待',
    roomCode: 'ルームコード',
    please_enter_a_valid_room_code: '有効な引き換えコードを入力してください',
    notice: '通知',
    time_difference_reminder:
      'システム時刻とインターネット時刻に異常な差異があります。これはプレイヤーのカウントダウン機能に影響を与える可能性があります。できるだけ早くシステム時刻を同期してください。同期済みの場合は、ページをリフレッシュしてください。',
    register_success: '登録に成功しました',
    referral_code: '紹介コード',
    referral_code_placeholder: '紹介コードを入力',
    display_name: '表示名',
    display_name_placeholder: '表示名を入力',
    user: 'プレイヤー',
    bet_amount: 'ベット額',
    date: '日付',
    multiplier: '倍率',
    payout: '賞金',
    free_game: '無料ゲーム',
    play_without_money: 'お金なしでプレイ',
    private_game: 'プライベートルーム',
    play_with_friends: '友達と一緒にプレイ',
    regular_content: '通常のテキサスホールデムは無制限ベット方式を採用しています',
    all_in_content:
      'オールインまたはフォールドテキサスホールデムは無制限ベット方式を採用しています',
    short_content: 'ショートデッキテキサスホールデムは無制限ベット方式を採用しています',
    omaha_content: 'ポットリミットオマハは無制限ベット方式を採用しています',
    omaha_all_in_content: 'オールインまたはフォールドオマハは無制限ベット方式を採用しています',
    player_statistics: 'プレイヤー状況',
    lucky_draw_reminder: {
      title: 'リマインダー',
      message: '{{value}}回のラッキードローが残っています',
      go_to_lucky_draw: 'ラッキードローに行く',
      spin_now: '今すぐスピン',
    },
  },
  disclaimer: {
    title: '免責事項',
    message: '以下の制限地域に居住している場合、win4.pokerでゲームを行うことは許可されていません',
    countryList:
      'アメリカ、トルコ、アルバ、ボネール、キュラソー、フランス、オランダ、スウェーデン、イスラエル、リトアニア、スロバキア、ベルギー、スイス、サバ、セントユースティス、セントマーチン、中国、イギリス。',
    checkbox_message:
      '私は、私の所在地の当局によってギャンブルが禁止されておらず、18歳以上であることを確認します。',
    required_message: '免責事項に同意してください',
  },
  login: {
    user_account: 'ユーザーアカウント',
    password: 'パスワード',
    cash_web_login: 'キャッシュウェブユーザーログイン',
    player_register: 'プレイヤー登録',
    gateway_user_name: 'Gatewayユーザー名',
    cms_login: 'CMSログイン',
    deposit: '入金',
    deposit_amount: '入金額',
    deposit_message: '入金額を入力する必要があります',
    notice: '通知',
    duplicate_login: '同じIPでのログインが検出されました',
    redirecting: 'ページがまもなく読み込まれます。ご理解いただきありがとうございます。',
    loading: 'リソースを読み込んでいます。しばらくお待ちください...',
  },
  verification: {
    email_verification_code: 'メール認証コード',
    email_not_verify_error: 'メールが認証されていません',
    confirm: '確認',
    timer_count: 'タイマーカウント',
    resend_verification_code: '認証コードを再送信',
    send_verification_code: '認証コードを送信',
    input_field: '{{field}}を入力',
    code: 'コード',
    successful_verify: '認証に成功しました',
    two_factor_authentication: '二段階認証',
    verification: '認証',

    // KYC page
    verify: '身分証明',
    security: 'セキュリティ',

    kyc_status: {
      failed_verify_again: '認証に失敗しました。再試行してください',
      under_review: '認証中',
      verify_now: '今すぐ認証',
    },

    complete_email_verification_to_unlock_some_function: 'メール認証を完了してXXX機能をアンロック',
    complete_id_verification_to_upgrade_withdrawal_amount:
      '身分証明書認証を完了して出金額を100,000 USDTにアップグレード',
    requirement: '要件',
    verify_now: '今すぐ認証',

    verification_code: '認証コード',
    email_verification: {
      title: 'メール認証',
      msg: '認証コードを受信できるメールアドレスを入力してください。',
      otp_has_been_sent_to: '{{value}}に認証コードが送信されました',
    },

    id_card: '身分証明書',
    passport: 'パスポート',

    identity_verification: {
      title: '身分証明書認証',
      msg: '有効な身分証明書を使用して認証してください。',
      issuing_country: {title: '発行国を選択', placeholder: '国を選択'},
      document_type: {
        title: '身分証明書の種類を選択',
        placeholder: '身分証明書の種類を選択',
      },
    },

    uploadDocument: {
      title: 'ドキュメントのアップロード',
      make_sure_that_your: 'ドキュメントが',
      is_clear_and_easy_to_read: '明確で読みやすいことを確認してください',
      is_unedited: '編集されていないこと',
      the_whole_doc_must_appear_in_photo: 'ドキュメント全体が写真に写っていること',
      no_reflective_glare: '反射光がないこと',

      upload_image: '写真をアップロード',
      upload_image_requirement: 'ファイルサイズは10MB未満で、jpegまたはpng形式をサポートします。',
      front_side_of_id: '身分証明書の表面',
      back_side_of_id: '身分証明書の裏面',
      personal_data_page_of_passport: 'パスポートの個人データページ',
      document_uploaded: 'ドキュメントがアップロードされました',
      id_document_under_review_msg:
        'あなたの身分証明書は審査中であり、認証が完了するまでに1〜2営業日かかる場合があります。',
    },

    disable_2fa: {
      title: '二段階認証を無効にする',
      description:
        '操作を続行するには、認証アプリで提供された認証コードを入力して本人確認を行ってください',
      success_message: '二段階認証を無効にしました',
    },

    error_messages: {
      document_upload_required: 'ドキュメントをアップロードしてください',
      selection_required: 'オプションを選択してください',
    },
  },
  table_area: {
    pot: 'ポット',
    waiting_for_other_players: '他のプレイヤーの参加を待っています...',
    waiting_for_game_start: 'ゲーム開始を待っています',
    sixty_sec: '60秒',
    please_select_emoji_target: 'プレイヤーを選択してください',
  },
  best_combination: {
    hi_card: 'ハイカード ({{value}})',
    one_pair: 'ワンペア ({{value}})',
    two_pairs: 'ツーペア ({{firstPair}}, {{secondPair}})',
    set: 'スリーオブアカインド ({{value}})',
    straight: 'ストレート ({{fromValue}} から {{toValue}} まで)',
    flush: 'フラッシュ ({{value}} ハイカード)',
    fullHouse: 'フルハウス ({{three_cards}} と {{two_cards}})',
    quad: 'フォーオブアカインド ({{value}})',
    straight_flush: 'ストレートフラッシュ ({{fromValue}} から {{toValue}} まで)',
    royal_flush: 'ロイヤルフラッシュ',
  },
  action_buttons: {
    place_bet: 'ベットを配置',
    all_in: 'オールイン',
    bet: 'ベット',
    check: 'チェック',
    call: 'コール',
    raise: 'レイズ',
    fold: 'フォールド',
    pot: 'ポット',
    confirm: '確認',
    investment: '投資',
    insurance: '保険',
    choosing_cards: 'カードを選択',
    outs_number: 'OUTS数',
    insurance_winning_rate: '勝率',
    odds: 'オッズ',
    premium: '保険料',
    payout: '賞金',
    call_any: 'オートコール',
    wait_for_blinds: 'ブラインド後に参加',
    join_directly: '次のラウンドに参加',
    check_or_fold: 'チェック / フォールド',
    confirm_to_fold: 'フォールドしてもよろしいですか？',
    max: '最大',
    min: '最小',
    force_insurance: '保険を強制する',
  },
  history_drawer: {
    title: 'ルーム履歴',
    small_blind: 'スモールブラインド(アンティ)',
    pre_flop: 'プリフロップ',
    flop: 'フロップ',
    turn: 'ターン',
    river: 'リバー',
    no_data: 'ルームデータがありません',
    hands: 'ハンド',
    winner: '勝者',
    buy_in: '購入',
    pool: 'ポット',
    win_player: '勝者プレイヤー',
    time: '時間',
    main_pot: 'メインポット',
    side_pot_one: 'サイドポット 1',
    side_pot_two: 'サイドポット 2',
    side_pot_three: 'サイドポット 3',
    win: '勝ち',
    loading: '読み込み中',
    all_record_loaded: 'すべてのルーム履歴が読み込まれました',
    previous_page: '前のページ',
    close: '閉じる',
    detail: '詳細',
  },
  file_upload: {
    upload: 'アップロード',
  },
  user_menu: {
    two_factor: '二段階認証',
    change_password: 'パスワード変更',
    logout: 'ログアウト',
    hello_user: 'こんにちは',
  },
  change_password_board: {
    change_password: 'パスワード変更',
    old_password: '旧パスワード',
    new_password: '新パスワード',
    confirm_password: 'パスワードを確認',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: '検索...',
    filter: 'フィルター',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: '読む',
    write: '書く',
    none: 'なし',
    banned: '禁止',
  },
  phone_input: {
    invalid_country_code: '無効な国コード',
    invalid_phone: '無効な電話番号',
    phone_number: '電話番号',
    phone_code: '地域番号',
  },
  room_setting_drawer: {
    create_new_room: '新しいルームを作成',
    enter_room_code: 'ルームコードを入力',
    please_enter_a_valid_room_code: '有効な引き換えコードを入力してください',
    please_input_room_code: 'ルームコードを入力してください',
    enter_room: 'ルームに参加',
    room_setting: 'ルーム設定',
    small_blind: 'ブラインド:',
    ante: 'アンティ:',
    buy_in: '購入:',
    number_of_people: '人数:',
    action_time: 'アクションタイム:',
    game_duration: 'ゲーム時間:',
    commission: 'コミッション:',
    insurance: '保険:',
    location_restriction: '場所制限',
    diamond_needed: '必要なダイヤモンド:',
    diamond_owned: '所有しているダイヤモンド:',
    redeem: 'ダイヤモンドを購入',
    open_room: 'ルームを開く',
    maximum: '上限:',
    hours: '{{value}}時間',
    minute: '{{value}}分',
    second: '{{value}}秒',
    affect_diamond_needed: '必要なダイヤモンドに影響',
    remaining_room_time: 'ルーム終了まで残り時間',
    diamond_require: '必要なダイヤモンド:',
    time_increase: '時間を追加:',
    recharge: 'チャージ',
    isAllIn: 'オールイン',
    ipchecking: 'IP制限',
    diamond_not_enough: 'ダイヤモンド残高が不足しています',
  },
  gameRecharge: {
    sticker_title: 'ステッカー',
    check_for_more: 'もっと見る',
    diamond_title: 'ダイヤモンド',
    diamond_product_tag: '{{value}} ダイヤモンド',
    buy_diamond_confirm_msg: '購入を確認',
    buy_sticker_confirm_msg: 'この絵文字ステッカーを購入しますか？',
    balance_not_enough_msg: '残高が不足しています',
    sticker_product_tag: '{{value}}ダイヤモンドが必要です',
    confirm_to_buy_button: '確認',
    confirm_title: '購入確認',
    confirm_message:
      'USD$ <0>{{usdAmount}}</0>で<1>{{diamondAmount}}ダイヤモンド</1>を購入してもよろしいですか？',
    redeem: 'チャージ',
    confirm: '確認',
    reminder: 'リマインダー',
    not_enough_money: '申し訳ありませんが、ダイヤモンドを購入するのに十分な残高がありません。',
    not_enough_diamond: 'ダイヤモンドの残高が不足しています。まずダイヤモンドを購入してください。',
    quanity: '数量:',
    price: '価格:',
    diamond: 'ダイヤモンド',
    sticker: 'ステッカー',
    purchase_success: '購入に成功しました',
    purchase: '購入',
    diamond_balance: 'ダイヤモンド残高',
    free_sticker: 'これは無料商品です',
    amount_required: '数量を入力する必要があります',
    valid_amount: '有効な数量を入力してください',
    not_enough_diamond_balance: 'ダイヤモンド残高が不足しています',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'すべて',
      usd: 'USD',
      cash: '現金体験コード',
      diamond: 'ダイヤモンド',
    },
    transactionType: {
      createRoom: 'プライベートルームを開く',
      luckyDraw: 'ラッキードローをプレイ',
      purchaseItem: '絵文字ステッカーを購入',
      purchaseDiamond: '{{value}}ダイヤモンドを購入',
      joinGame: '{{value}}ゲームに参加',
      winGame: '{{value}}ゲームに勝利',
      loseGame: '{{value}}ゲームに敗北',
      winGameWithoutGameType: 'ゲームに勝利',
      loseGameWithoutGameType: 'ゲームに敗北',
      joinGameWithoutGameType: 'ゲームに参加',
      deposit: 'チャージ',
      redeemDemo: '現金コードと交換',
      insurance: '保険',
      gift: 'ギフト',
      firstLogin: '初回ログイン',
      privateRoomRebate: 'プライベートルームリベート',
    },
    transactionRecord: '取引明細',
    no_transaction_record: '取引記録がありません',
    currentMonth: '今月',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: 'この絵文字ステッカーを購入しますか？',
    sticker_product_tag: '{{value}}ダイヤモンドが必要です',
    confirm_to_buy_button: '購入を確認',
    emoji: '絵文字',
    free: '無料',
    no_available_emoji: '利用可能な絵文字ステッカーがありません',
  },
  playerInfo: {
    button: 'ディーラー',
    smallBlind: 'スモールブラインド',
    bigBlind: 'ビッグブラインド',
    cutOff: 'カットオフ',
    underTheGun: 'アンダーザガン',
    bet: 'ベット',
    check: 'チェック',
    call: 'コール',
    raise: 'レイズ',
    fold: 'フォールド',
    cancelInsurance: '保険を\nキャンセル',
    confirmInsurance: '保険を\n確認',
    allIn: 'オールイン',
    skip: 'スキップ',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: '入金方法',
    remark: '備考',
    ton_connect: 'TON接続',
    manual_deposit: '手動入金',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: '入金',
    withdraw: '出金',
    withdrawal: '出金',
    history: '入出金記録',
    blockchain: 'ブロックチェーン',
    currency: '通貨',
    network: 'ネットワーク',
    exchange_rate: '為替レート',
    deposit_address: '入金アドレス',
    deposit_process_message_1:
      'システムが入金を受け取ると、すぐに入金処理が行われます。処理には約2時間かかるので、しばらくお待ちください。',
    back: '戻る',
    address: 'アドレス',
    transaction_id: '取引ID',
    amount: '引き出し数量',
    time: '時間',
    coin_type: '通貨タイプ',
    available_amount: '引き出し可能額',
    withdraw_amount: '引き出し数量',
    withdraw_cost: '引き出し手数料',
    receiving_amount: '受取予定額',
    deposit_amount: '入金数量',
    deposit_amount_placeholder: '入金数量を入力してください',
    no_data: 'データがありません',
    address_placeholder: 'アドレスを入力してください',
    amount_placeholder: '数量を入力してください',
    withdrawal_amount: '引き出し数量',
    withdrawal_fee: '引き出し手数料',
    max: '最大',
    available_cash_out_balance: '引き出し可能残高',
    cash_out_info:
      '賞金プールに参加した後、あなたはポーカーゲームで獲得したUSDTのみを引き出すことができ、ゲームが引き分けの場合は引き出すことができます。',
    wallet_balance: 'ウォレット残高',
    deposit_pending_title: '入金待ち',
    deposit_pending_description: 'あなたの入金は現在承認待ちです',
    deposit_success_title: '入金成功',
    deposit_success_description: '資金があなたのアカウントに入金されました',
    create_withdraw_success_title: '出金リクエスト成功',
    create_withdraw_success_description: 'あなたの出金リクエストは処理中です',
    withdrawal_success_title: '出金成功',
    withdrawal_success_description: 'あなたの出金リクエストが完了しました',
    amount_required: '金額が必要です',
    amount_exceeds_available: '金額が利用可能残高を超えています',
    amount_below_minimum: '金額が最低限度額に満たない',
    amount_below_fee: '金額が手数料に満たない',
    invalid_number: '無効な数値',
    network_required: 'ネットワークを選択する必要があります',
    address_required: 'アドレスを入力する必要があります',
    blockchain_required: 'ブロックチェーンを選択する必要があります',
    email_required: 'メールを入力する必要があります',
    valid_amount: '有効な金額を入力してください',
    notice: '通知',
    cancel: 'キャンセル',
    cancel_transaction: '取引をキャンセルしました',

    from: '送信元',
    receive_amount: '受取金額',

    // 2FA
    two_fa_required_msg: 'セキュリティのため、出金前に二段階認証を設定する必要があります。',
    setup_2fa: '二段階認証を設定',
    lost_my_2fa_access: '二段階認証へのアクセスを失いました',

    wallets_usdt_token: 'ウォレットのUSDTトークン',
    memo_reminder_1:
      '備考欄に{{memo}}を入力していることを確認してください。入力が間違っている場合、当システムはお客様のアカウントに資金を入金することができません。',
    memo_reminder_2: 'TonConnectを使用している場合、システムが自動的に入力します。',

    wait_for_next_lucky_draw:
      '次回のラッキードローイベントをお待ちください。プレイ資金を獲得するチャンスがあります。',
  },
  history_status: {
    completed: '完了',
    pending: '処理中',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'すべてのフロー',
      deposits: '入金',
      withdrawals: '出金',
      bets: 'ベット',
      purchase: 'ダイヤモンド購入',
      diamond: 'ダイヤモンド',
    },
    transaction_type: '取引タイプ',
    transaction_types: {
      deposits: '入金',
      withdrawals: '出金',
      bets: 'ベット',
      purchase: 'ダイヤモンド購入',
      diamond: 'ダイヤモンド',
      purchase_item: 'ダイヤモンド取引',
      referral_commission: '紹介手数料',
      payout: '賞金',
      private_room: 'プライベートルームを開く',
      private_room_rebate: 'プライベートルームリベート',
      reward: '報酬',
      lucky_draw: 'ラッキードロー',
      tournament_prize: 'トーナメント賞金',
      tournament_ticket_fee: 'トーナメントチケット料金',
    },
    game_type: 'ゲームタイプ',
    type: 'タイプ',
    bet: 'ベット',
    payout: '賞金',
    amount: '金額',
    quantity: '数量',
    balance: '残高',
    diamond: 'ダイヤモンド',
    sticker: 'ステッカー',
  },
  referral: {
    referral: '紹介',
    invite_friends_description: '友達をWin4Pokerに招待して報酬を獲得',
    whatsapp_referral_message:
      '勝つ準備はできていますか？🃏 Win4Pokerで私と一緒に素晴らしい対戦を楽しみましょう！ これは私の招待リンクです： ',
    number_of_referrals: '紹介人数',
    referral_rewards: '紹介報酬',
    my_commission: '私のコミッション',
    referral_code: '紹介コード',
    referral_link: '紹介リンク',
    enter_code: 'コードを入力',
    terms_and_conditions: 'Win4Poker 利用規約',
    invite_friends: '友達を招待',
    pop_up_title: '通知',
    back_home: 'ホームに戻る',
    scan_qr_code: 'QRコードをスキャン',
    code: 'コード',
    copy_link: 'リンクをコピー',
    save_image: '画像を保存',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: 'もっと',
    referral_history: '紹介履歴',
    register_time: '登録時間',
    player: 'プレイヤー',
    reward_time: '報酬時間',
    reward_amount: '報酬金額',
    referral_list: '紹介リスト',
    enter: '入力',
    skip: 'スキップ',
    please_input_referral_code: '紹介コードを入力してください',
    enter_referral_code: '紹介コードを入力',
    enter_referral_code_success: '紹介コードの入力に成功しました',
    cannot_use_own_referral_code: '自分の紹介コードを使用できません',
    total: '合計',
    referral_code_invalid: '紹介コードが無効です',
    commission: 'コミッション',
    reward_type: '報酬タイプ',
    amount: '金額',
    commission_reward: 'コミッション報酬',
    commission_update_success: 'コミッションの更新に成功しました',
    commission_setting: 'コミッション設定',
    save: '保存',

    // title
    promotion_1: 'プロモーション1：入金ボーナス',
    promotion_2: 'プロモーション2：紹介コード報酬',
    general_terms: '一般利用規約',

    commission_calculation: {
      title: 'コミッション計算',
      first_layer: '第1層 %',
      second_layer: '第2層 %',
      third_layer: '第3層 %',
      refers: '紹介',
      referrer: '紹介者',
      content:
        '勝利金の5%がコミッションとして控除されます。ゲートウェイは<0>最大</0>でコミッションの30%を受け取ります。ゲートウェイはコミッションの残りの70%を最上位の紹介者に分配し、その紹介者はコミッションの70%のうちZ%を次のレベルの紹介者に割り当てることができます。次のレベルの紹介者は、コミッションのZ%のうちY%を下のレベルに分配することを決定でき、このプロセスはコミッションが勝者の紹介者に到達するまで続きます。',
      example: {
        title: '例：',
        winner_wins: '勝者の獲得額：${{value}}',
        total_commission: '総コミッション：${{value}}',
        gateway_total_commission_max: 'ゲートウェイ総コミッション（最大）：${{value}}',
        referral_total_commission_min: '紹介総コミッション（最小）：${{value}}',

        referral_commissions: '紹介コミッション（70 ≥ Z ≥ Y ≥ X ...）：',
        referrer_1_commission: '紹介者1：${{totalCommission}} ×（Z% - Y%）',
        referrer_2_commission: '紹介者2：${{totalCommission}} ×（Y% - X%）',
        referrer_3_commission: '紹介者3：${{totalCommission}} × X%',
      },
    },

    // sub-title
    eligibility: '資格',
    offer: 'オファー',
    conditions: '条件',
    program_duration: 'プログラム期間',
    account_verification: 'アカウント認証',
    limitations: '制限',
    modification_of_terms: '規約の変更',
    compliance: 'コンプライアンス',
    support: 'サポート',

    error_messages: {
      referral_code_invalid:
        'リファラルコードは4〜8文字でなければならず、"I"と"O"を除く英数字のみを含むことができます',
      referral_code_required: 'リファラルコードは必須です',
    },

    // points
    eligibility_1: 'ユーザーはWin4Pokerアカウントに1 USDT以上を入金している必要があります。',
    offer_1: '資格のあるユーザーは1 USDTの無料ギフトを受け取り、直接アカウントに入金されます。',
    conditions_1: 'このオファーには制限はありません。',
    conditions_2: '入金はWin4Pokerが指定した紹介期間内に行われる必要があります。',
    conditions_3:
      'ユーザーはこの紹介資格を満たすために認証済みのアカウントを持っている必要があります。',

    eligibility_2: 'ユーザーはユニークな紹介コードを使用して友達を紹介する必要があります。',
    offer_2:
      '紹介された友達が最初のゲームを完了すると、紹介者はプール総額の最大3.5％を報酬として受け取ります。',
    conditions_4: '紹介された友達は紹介者のコードを使用して登録する必要があります。',
    conditions_5: '報酬は紹介された友達がゲームを完了してから2時間以内に支払われます。',
    conditions_6: 'ユーザーはアカウントダッシュボードを通じて紹介と報酬を追跡できます。',
    program_duration_1:
      'これらの紹介キャンペーンは、当社のウェブサイトおよび公式チャネルで通信される指定された期間内に実施されます。',
    account_verification_1:
      '参加者は、どの報酬資格も満たすために完全に認証されたアカウントを持っている必要があります。',
    limitations_1:
      '紹介システムの乱用（例：自己紹介）と見なされたユーザーは、アカウントが一時停止または無効化される可能性があります。',
    modification_of_terms_1:
      'Win4Pokerは、予告なしにこれらの紹介キャンペーンをいつでも変更または終了する権利を留保します。',
    compliance_1:
      '参加者は、自分の司法管轄区域内で適用されるオンラインゲームおよび紹介に関連する法律および規制を遵守する必要があります。',
    support_1:
      '紹介プログラムに関する質問や支援が必要な場合は、カスタマーサポートチームにお問い合わせください。',

    // disclaimer
    disclaimer: '免責事項',
    disclaimer_1:
      'すべての報酬は在庫に制限されており、アカウントの状態やアクティビティに応じて変更される場合があります。',
    disclaimer_2:
      'Win4Pokerは、紹介や報酬の追跡を妨げる可能性のある技術的な問題について責任を負いません。',

    fixed_commission: '固定コミッション',
    custom_commission: 'カスタムコミッション',
    invalid_commission_percentage: '無効なコミッションパーセンテージ',
    commission_placeholder: 'コミッションパーセンテージを入力してください',
    my_share: '私のシェア',
  },
  ranking: {
    ranking: 'ランキング',
    today: '今日',
    this_week: '今週',
    this_month: '今月',
  },
  tournament: {
    you_have_won: 'あなたは勝ちました',
    time_elapsed: '経過時間',
    prize_pool: '賞金プール',
    entries: 'エントリー数',
    of: 'の',
    congratulations: 'おめでとうございます',
    thanks_for_your_joining: 'ご参加ありがとうございます',
    watch: '観戦',
    see_result: '結果を見る',
    view_tournament: 'トーナメントを見る',
    deregister: '登録解除',
    start_in: '<0>countdown</0>後に開始',
    full: '満席',
    register_end_in: '登録は<0>countdown</0>後に終了',
    my_ranking: '自分のランキング',
    players: 'プレイヤー',
    register: '登録',
    pay_for_registration: '登録のために {{ticketFee}} を支払う',
    register_confirmation_message:
      'トーナメントに登録するには、{{ticketFee}} のチケット料金が発生します。{{tournamentName}} に登録しますか？',
    late_register: '遅延登録',
    level: 'レベル',
    blinds: 'ブラインド（SB/BB）',
    ante: 'アンティ',
    duration: '期間',
    game_rule: 'ゲームルール',
    game_mode: 'ゲームモード',
    speed: 'スピード',
    general_information: '一般情報',
    ticket_fee: 'チケット料金',
    starting_stack: '開始スタック',
    blinds_start: 'ブラインド開始',
    ante_starts: 'アンティ開始',
    raised_every: '上昇間隔',
    minutes: '分',
    prize: '賞金',
    structure: '構造',
    gameModeTitle: {
      classic: 'クラシック',
      turbo: 'ターボ',
      hyper: 'ハイパー',
    },
    gameModeDescription: {
      classic:
        'クラシックマルチテーブルトーナメント。参加者は総賞金プールの一部を獲得するために競います。',
    },
    speedTitle: {
      regular: 'レギュラー',
      turbo: 'ターボ',
      hyper: 'ハイパー',
    },
    speedDescription: 'ブラインドは{{value}}分ごとに上昇します',
    tournament: 'トーナメント',
    today: '今日',
    yesterday: '昨日',
    tomorrow: '明日',
    upcoming: '今後の予定',
    results: '結果',
    on_going: '進行中',
    title: 'トーナメント詳細',
    tables: 'テーブル',
    minutes_short: '分',
    current_blinds: '現在のブラインド',
    next_blind_at: '次のブラインド時間',
    start_game_in: 'ゲーム開始まで',
    no_tournaments_available: '利用可能なトーナメントはありません',
    you_have_not_participated_in_any_tournament_yet: 'まだトーナメントに参加していません',
    tournament_started: 'トーナメント開始',
    tournament_ended_msg: 'トーナメント終了',
    tournament_canceled_msg: 'トーナメントがキャンセルされました',
    view_table: 'テーブルを見る',
    view_player_table: 'プレイヤーテーブルを見る',
    table_rebalancing: 'テーブルリバランシング',
    upcoming: '今後の予定',
    in_progress: '進行中',
    finished: '終了',
    waiting_enough_players_to_start: '十分なプレイヤーが集まるのを待っています',
    cancelled: 'キャンセルされました',
    table_rebalancing: 'テーブルの再バランス',
    too_many_rooms_description:
      '{{tournamentName}}がもうすぐ始まりますが、最大テーブル数に達しています。{{tournamentName}}に参加するには、以下のテーブルから少なくとも1つ離れてください。',
    leave: '離れる',
    sit_in: '{{name}}に参加',
    ignore: '無視',

    re_entry_modal: {
      title: 'トーナメントに再参加しますか？',
      description:
        '{{tournamentName}}はまだ参加可能です。${{ticketFee}}のチケット料金を支払ってトーナメントに再参加しますか？',
      re_enter: '再参加',
      view_tournament: 'トーナメントを見る',
    },
    waiting_for_players: {
      title: 'プレイヤーを待っています',
      message: 'あと{{count}}人のプレイヤーを待っています',
      message_plural: 'あと{{count}}人のプレイヤーを待っています',
    },
    thanks_for_joining: {
      title: 'ご参加ありがとうございます！',
      description: '{{tournamentName}}にご参加いただきありがとうございます。トーナメントはまだ進行中です。後で結果をご確認ください。',
      view_results: 'トーナメント結果を見る',
    },
    cancel: {
      title: 'トーナメントがキャンセルされました',
      description: 'トーナメント「{{tournamentName}}」がキャンセルされました。',
      refund_message: 'エントリー料金${{amount}}は返金されます。',
      confirm: 'OK',
    },
    waiting_timer: {
      title: 'プレイヤーを待っています',
      cancel_in: 'キャンセルまで',
    },
    waiting_for_players_timer: 'プレイヤーを待っています',
    cancel_in: 'キャンセルまで',
  },
  errorCodes: {
    default: {
      title: 'システムエラー',
      message: '何かがうまくいきませんでした。後で再試行してください',
    },

    WS_0000: 'システムエラー',
    WS_0001: '4つ以上のルームに参加できません',
    WS_0002: '最大ベット中に退出できません',
    WS_0003: '認証エラー。ページをリフレッシュしてもう一度試してください',
    WS_0004: 'ルーム内に近くに人が検出されたため、現在そのルームに参加できません',
    WS_0005: '最高ベットを持つプレイヤーを退出できません。まずフォールドしてください',
    WS_0006: '購入エラー',
    WS_0007: 'ゲームルームが見つかりません',

    HP_0001: '4つ以上のルームに参加できません',
    HP_0002: '現在サーバーに接続できません。後ほど再試行してください。',
    HP_0003: '購入金額が不足しています',
    HP_0004: '無効な認証コード',
    INVALID_EMAIL_PASS_CODE: '無効な認証コード',
    INVALID_OTP: '無効な認証コード',
    INVALID_REFERRAL_CODE: '無効な紹介コード',
    REFERRAL_CODE_ALREADY_USED: '紹介コードは既に使用されています',
    INSUFFICIENT_COINS: '財布残高不足',
    JOIN_TOURNAMENT_ERROR: 'トーナメントへの参加エラー',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: '位置情報へのアクセスが拒否されました。',
      POSITION_UNAVAILABLE: '位置情報が利用できません。後でもう一度お試しください。',
      TIMEOUT: '位置情報の取得要求がタイムアウトしました。もう一度お試しください。',
      UNKNOWN: '位置情報の要求中に不明なエラーが発生しました。',
    },
    TOURNAMENT_IS_FINISHED: 'トーナメントは終了しました',
    GPS_RESTRICTION:
      '位置を検出できないか、近くのプレイヤーが同じルームに参加しています。後でもう一度お試しください',
  },
};
